import { useMutation } from '@apollo/client';
import { AUTH_CONFIGS, DELETE_AUTH_CONFIG } from '../graphql/queries/authConfig';
import { useFetchItems } from './useFetchItems';
export const useAuthConfigs = ({ clientId, provider, excludeGuildAuth = true, includeInactive = true, }) => {
    const { items, error, loading } = useFetchItems({
        fetchQuery: AUTH_CONFIGS,
        dataProp: 'authConfigs',
        skip: !clientId,
        spec: { clientId, provider, excludeGuildAuth, includeInactive },
    });
    const [deleteAuthConfig] = useMutation(DELETE_AUTH_CONFIG, {
        refetchQueries: [
            {
                query: AUTH_CONFIGS,
                variables: { spec: { clientId, provider, excludeGuildAuth, includeInactive } },
            },
        ],
    });
    return {
        items,
        error,
        loading,
        deleteAuthConfig,
    };
};
